import { api } from "./api";

// Préchargement au démarrage : le fil (ou les Reels) et les stories sont demandés à t=0, EN PARALLÈLE de
// config/public et auth/me, au lieu d'attendre la fin de l'authentification → premier rendu du fil plus tôt.
// Consommé UNE fois par la première requête identique (même URL + mêmes paramètres) ; au-delà de 15 s → ignoré.
const store = new Map();
const keyOf = (url, params) => {
  const p = params || {};
  return url + "?" + Object.keys(p).sort().map((k) => `${k}=${p[k]}`).join("&");
};

export const bootPrefetch = (url, params) => {
  const k = keyOf(url, params);
  if (store.has(k)) return;
  const promise = api.get(url, { params }).catch((e) => { store.delete(k); throw e; });
  store.set(k, { at: Date.now(), promise });
};

export const takePrefetched = (url, params, maxAgeMs = 15000) => {
  const k = keyOf(url, params);
  const e = store.get(k);
  if (!e) return null;
  store.delete(k);
  return Date.now() - e.at > maxAgeMs ? null : e.promise;
};

// Remplaçant de api.get pour la 1re page d'une liste : sert le préchargement s'il existe, sinon requête normale.
export const prefetchedGet = (url, opts = {}) => takePrefetched(url, opts.params) || api.get(url, opts);
